import { createActions } from 'redux-actions'

export const {
  getCompanyProductListRequest,
  getCompanyProductListSucceed,
  getProductDetailRequest,
  getProductDetailSucceed,
  createProductRequest,
  createProductSucceed,
  updateProductRequest,
  updateProductSucceed,
  archiveProductRequest,
  archiveProductSucceed,
  clearProductDetail,
  requestFailure
} = createActions(
  {
    GET_COMPANY_PRODUCT_LIST_REQUEST: ({
      page,
      limit,
      sortBy,
      sortDirection,
      companyId,
      isDeleted
    }) => ({
      page,
      limit,
      sortBy,
      sortDirection,
      companyId,
      isDeleted
    }),
    GET_COMPANY_PRODUCT_LIST_SUCCEED: (productList) => productList,
    GET_PRODUCT_DETAIL_REQUEST: (productId) => productId,
    GET_PRODUCT_DETAIL_SUCCEED: (productDetail) => productDetail,
    CREATE_PRODUCT_REQUEST: (productDetail) => productDetail,
    CREATE_PRODUCT_SUCCEED: (productDetail) => productDetail,
    UPDATE_PRODUCT_REQUEST: ({ productId, productDetail }) => ({
      productId,
      productDetail
    }),
    UPDATE_PRODUCT_SUCCEED: (productDetail) => productDetail,
    ARCHIVE_PRODUCT_REQUEST: ({ productId, companyId }) => ({
      productId,
      companyId
    }),
    ARCHIVE_PRODUCT_SUCCEED: undefined,
    CLEAR_PRODUCT_DETAIL: undefined,
    REQUEST_FAILURE: (err) => err
  },
  { prefix: 'PRODUCT' }
)
